import { render, staticRenderFns } from "./relationships-card.vue?vue&type=template&id=73f0f458"
import script from "./relationships-card.vue?vue&type=script&lang=js"
export * from "./relationships-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports